<template>
  <div class="footer">
    <a
      href="mailto:me.jefferson@gmail.com"
      rel="noopener noreferrer"
      target="_blank">
      email
    </a>
    <a
      href="https://www.github.com/jpecht"
      rel="noopener noreferrer"
      target="_blank">
      github
    </a>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
.footer {
  background-color: rgba(0, 0, 0, 0.3);
  bottom: 0;
  padding: 20px 20px;
  position: fixed;
  text-align: center;
  width: 100%;
}

a {
  color: inherit;
  margin: 0 15px;
  text-decoration: none;
}

a:hover {
  color: white;
  text-decoration: underline;
}
</style>
